import { FC } from 'react';
import { IconProps, IconColor } from '../types';

export const WarningIcon: FC<IconProps & { withExternalCircle?: boolean }> = ({
  width = 16,
  height = 16,
  withExternalCircle = false,
  fillColor = IconColor.YELLOW,
  ...props
}) => {
  if (withExternalCircle)
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect width="24" height="24" rx="12" fill={fillColor} fillOpacity="0.15" />
        <path
          d="M14.75 15.9167L15.9166 14.7501L12.8333 11.6667V7.83341H11.1666V12.3334L14.75 15.9167ZM12 20.3334C10.8472 20.3334 9.76385 20.1147 8.74996 19.6772C7.73607 19.2397 6.85413 18.6459 6.10413 17.8959C5.35413 17.1459 4.76038 16.264 4.32288 15.2501C3.88538 14.2362 3.66663 13.1529 3.66663 12.0001C3.66663 10.8473 3.88538 9.76397 4.32288 8.75008C4.76038 7.73619 5.35413 6.85425 6.10413 6.10425C6.85413 5.35425 7.73607 4.7605 8.74996 4.323C9.76385 3.8855 10.8472 3.66675 12 3.66675C13.1527 3.66675 14.2361 3.8855 15.25 4.323C16.2638 4.7605 17.1458 5.35425 17.8958 6.10425C18.6458 6.85425 19.2395 7.73619 19.677 8.75008C20.1145 9.76397 20.3333 10.8473 20.3333 12.0001C20.3333 13.1529 20.1145 14.2362 19.677 15.2501C19.2395 16.264 18.6458 17.1459 17.8958 17.8959C17.1458 18.6459 16.2638 19.2397 15.25 19.6772C14.2361 20.1147 13.1527 20.3334 12 20.3334Z"
          fill={fillColor}
        />
      </svg>
    );

  return (
    <svg
      fill="none"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.7501 13.9166L13.9167 12.75L10.8334 9.66663V5.83329H9.16675V10.3333L12.7501 13.9166ZM10.0001 18.3333C8.8473 18.3333 7.76397 18.1145 6.75008 17.677C5.73619 17.2395 4.85425 16.6458 4.10425 15.8958C3.35425 15.1458 2.7605 14.2638 2.323 13.25C1.8855 12.2361 1.66675 11.1527 1.66675 9.99996C1.66675 8.84718 1.8855 7.76385 2.323 6.74996C2.7605 5.73607 3.35425 4.85413 4.10425 4.10413C4.85425 3.35413 5.73619 2.76038 6.75008 2.32288C7.76397 1.88538 8.8473 1.66663 10.0001 1.66663C11.1529 1.66663 12.2362 1.88538 13.2501 2.32288C14.264 2.76038 15.1459 3.35413 15.8959 4.10413C16.6459 4.85413 17.2397 5.73607 17.6772 6.74996C18.1147 7.76385 18.3334 8.84718 18.3334 9.99996C18.3334 11.1527 18.1147 12.2361 17.6772 13.25C17.2397 14.2638 16.6459 15.1458 15.8959 15.8958C15.1459 16.6458 14.264 17.2395 13.2501 17.677C12.2362 18.1145 11.1529 18.3333 10.0001 18.3333Z"
        fill={fillColor}
      />
    </svg>
  );
};
